module.exports = __webpack_public_path__ + "img/jacket-front-sub-raglan-hood.01ba1452.png";